//import React from 'react';
import { React, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Card, Row, Col, CardBody } from 'reactstrap';
import { H4, H6, Image } from '../../../AbstractElements';

import CountUp from 'react-countup';
import WidgetImg from '../../../assets/images/dashboard-2/widget-img.png';
import MobileGif from '../../../assets/images/dashboard-2/mobile.gif';
import BoardTimer from '../../Application/Board/BoardTimer';
import NewsTicker from "react-advanced-news-ticker";

const BoardMeetingPanel = (props) => {//props.meetingParameters

  const [start, setStart] = useState(true);
  const [count, setCount] = useState(0);
  const [time, setTime] = useState("00:00:00");
  const [timeSetting, setTimeSetting] = useState({ m: 0, s: 0 });

  //alert(props.meetingParameters.meeting_start_time);

  var initTime = null;//new Date();

  if(props.meetingParameters.meeting_start_time!=undefined&&props.meetingParameters.meeting_start_time!=null){
    initTime = new Date(props.meetingParameters.meeting_start_time);
  }else {
    initTime = new Date();
  }

  const showTimer = (ms) => {
    const milliseconds = Math.floor((ms % 1000) / 10)
      .toString()
      .padStart(2, "0");
    const second = Math.floor((ms / 1000) % 60)
      .toString()
      .padStart(2, "0");
    const minute = Math.floor((ms / 1000 / 60) % 60)
      .toString()
      .padStart(2, "0");
     const hour = Math.floor(ms / 1000 / 60 / 60).toString();
    setTime(
       hour.padStart(2, "0") +
       ":" +
      minute + ":" + second 
    );
  };

  const clearTime = () => {
    setTime("00:00:00");
    setCount(0);
  };

 

  useEffect(() => {
    if (!start) {
      return;
    }
    var id = setInterval(() => {
      var left = count + (new Date() - initTime);
      setCount(left);
      showTimer(left);
      if (left <= 0) {
        setTime("00:00:00");
        //setTime(props.meetingParameters.meeting_start_time);
        clearInterval(id);
      }
    }, 1);
    return () => clearInterval(id);
  }, [start]);

  return (
    <Card className='o-hidden'>
      <CardBody className='balance-widget'>
      <Row >
       <Col md="4">
        <span className='f-w-500 f-light'><H6>{"Evaluation Board Meeting In Progress"}</H6></span>
        <H4 attrH4={{ className: 'mb-3 mt-1 f-w-500 mb-0 f-22' }}>
          {/*<CountUp prefix=' ' duration={5} start={0} separator=',' end={245154} />*/}
          <h3 className="timer">{time}</h3>
          {/*<span className='f-light f-14 f-w-400 ms-1'>{ThisMonth}</span>*/}
        </H4>
        <Link className='purchase-btn btn btn-primary btn-hover-effect f-w-500' >
          
          <div onClick={props.pinagareMeetingToggle} style={{color:'#ffffff'}}>{"End Meeting"}
          </div>
        </Link>
        </Col>
        <Col md="5" style={{textAlign: 'center'}}>
        <H6 style={{color:"#6ec6ec"}}><span style={{color:"#6ec6ec"}}>{"ATTENDING"}</span></H6>

<NewsTicker 
    rowHeight = {30}
    maxRows = {2}
    speed = {600}
    duration = {4000}
    autoStart = {true}
    pauseOnHover = {false}
    >
      {props.meetingParameters.meeting_attendees.map((item, i) => (
      item.firstname!=null? (<div><H6>{item.title+" "+item.firstname+" "+item.surname+" ("+item.position+")"}</H6></div> ):null
      ))}
  {/*<div><H6>{"Mr Ian Makgabana (Chairperson)"}</H6></div>
  <div><H6>{"Mrs Matildah Tshwarelo (Secretary)"}</H6></div>
  <div><H6>{"Mr Thato Mekgwe (Member)"}</H6></div>
  <div><H6>{"Mrs Neo Thekiso (Member)"}</H6></div>*/}

</NewsTicker>
        
        </Col>
        <Col md="3">
        <div className='mobile-right-img'>
          <Image attrImage={{ className: 'left-mobile-img', src: WidgetImg, alt: '' }} />
          <Image attrImage={{ className: 'mobile-img', src: MobileGif, alt: 'mobile with coin' }} />
        </div>
        </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default BoardMeetingPanel;
